import { render, staticRenderFns } from "./AssociatedProjectForm.vue?vue&type=template&id=5753e84f"
import script from "./AssociatedProjectForm.vue?vue&type=script&lang=js"
export * from "./AssociatedProjectForm.vue?vue&type=script&lang=js"
import style0 from "./AssociatedProjectForm.vue?vue&type=style&index=0&id=5753e84f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports